import React, { useRef } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import './index.css';
const MyDatePicker = ({ saveFormData, config, formcolor, formName, handleInput, showLabel,ifRequired , datetype, isDisabled}) => {
  let calendar = useRef()
  const localDate = config?.parameter_value ? new Date(config?.parameter_value) : ""
  const openDatepicker = () => calendar.setOpen(true);
  const closeDatepicker = () => calendar.setOpen(false);
  const [selected, setselected] = React.useState(localDate);
  
  const CalendarIcon = () => (
    <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 10.6666C7.76389 10.6666 7.56611 10.5866 7.40667 10.4266C7.24667 10.2672 7.16667 10.0694 7.16667 9.83329C7.16667 9.59718 7.24667 9.39913 7.40667 9.23913C7.56611 9.07968 7.76389 8.99996 8 8.99996C8.23611 8.99996 8.43417 9.07968 8.59417 9.23913C8.75361 9.39913 8.83333 9.59718 8.83333 9.83329C8.83333 10.0694 8.75361 10.2672 8.59417 10.4266C8.43417 10.5866 8.23611 10.6666 8 10.6666ZM4.66667 10.6666C4.43056 10.6666 4.2325 10.5866 4.0725 10.4266C3.91306 10.2672 3.83333 10.0694 3.83333 9.83329C3.83333 9.59718 3.91306 9.39913 4.0725 9.23913C4.2325 9.07968 4.43056 8.99996 4.66667 8.99996C4.90278 8.99996 5.10083 9.07968 5.26083 9.23913C5.42028 9.39913 5.5 9.59718 5.5 9.83329C5.5 10.0694 5.42028 10.2672 5.26083 10.4266C5.10083 10.5866 4.90278 10.6666 4.66667 10.6666ZM11.3333 10.6666C11.0972 10.6666 10.8994 10.5866 10.74 10.4266C10.58 10.2672 10.5 10.0694 10.5 9.83329C10.5 9.59718 10.58 9.39913 10.74 9.23913C10.8994 9.07968 11.0972 8.99996 11.3333 8.99996C11.5694 8.99996 11.7672 9.07968 11.9267 9.23913C12.0867 9.39913 12.1667 9.59718 12.1667 9.83329C12.1667 10.0694 12.0867 10.2672 11.9267 10.4266C11.7672 10.5866 11.5694 10.6666 11.3333 10.6666ZM8 14C7.76389 14 7.56611 13.92 7.40667 13.76C7.24667 13.6005 7.16667 13.4027 7.16667 13.1666C7.16667 12.9305 7.24667 12.7327 7.40667 12.5733C7.56611 12.4133 7.76389 12.3333 8 12.3333C8.23611 12.3333 8.43417 12.4133 8.59417 12.5733C8.75361 12.7327 8.83333 12.9305 8.83333 13.1666C8.83333 13.4027 8.75361 13.6005 8.59417 13.76C8.43417 13.92 8.23611 14 8 14ZM4.66667 14C4.43056 14 4.2325 13.92 4.0725 13.76C3.91306 13.6005 3.83333 13.4027 3.83333 13.1666C3.83333 12.9305 3.91306 12.7327 4.0725 12.5733C4.2325 12.4133 4.43056 12.3333 4.66667 12.3333C4.90278 12.3333 5.10083 12.4133 5.26083 12.5733C5.42028 12.7327 5.5 12.9305 5.5 13.1666C5.5 13.4027 5.42028 13.6005 5.26083 13.76C5.10083 13.92 4.90278 14 4.66667 14ZM11.3333 14C11.0972 14 10.8994 13.92 10.74 13.76C10.58 13.6005 10.5 13.4027 10.5 13.1666C10.5 12.9305 10.58 12.7327 10.74 12.5733C10.8994 12.4133 11.0972 12.3333 11.3333 12.3333C11.5694 12.3333 11.7672 12.4133 11.9267 12.5733C12.0867 12.7327 12.1667 12.9305 12.1667 13.1666C12.1667 13.4027 12.0867 13.6005 11.9267 13.76C11.7672 13.92 11.5694 14 11.3333 14ZM2.16667 17.3333C1.70833 17.3333 1.31583 17.1702 0.989167 16.8441C0.663055 16.5175 0.5 16.125 0.5 15.6666V3.99996C0.5 3.54163 0.663055 3.1494 0.989167 2.82329C1.31583 2.49663 1.70833 2.33329 2.16667 2.33329H3V1.49996C3 1.26385 3.07972 1.06579 3.23917 0.905793C3.39917 0.746348 3.59722 0.666626 3.83333 0.666626C4.06944 0.666626 4.2675 0.746348 4.4275 0.905793C4.58694 1.06579 4.66667 1.26385 4.66667 1.49996V2.33329H11.3333V1.49996C11.3333 1.26385 11.4133 1.06579 11.5733 0.905793C11.7328 0.746348 11.9306 0.666626 12.1667 0.666626C12.4028 0.666626 12.6006 0.746348 12.76 0.905793C12.92 1.06579 13 1.26385 13 1.49996V2.33329H13.8333C14.2917 2.33329 14.6842 2.49663 15.0108 2.82329C15.3369 3.1494 15.5 3.54163 15.5 3.99996V15.6666C15.5 16.125 15.3369 16.5175 15.0108 16.8441C14.6842 17.1702 14.2917 17.3333 13.8333 17.3333H2.16667ZM2.16667 15.6666H13.8333V7.33329H2.16667V15.6666Z" fill="#8F949B" />
    </svg>
  );

  const handleChange = (param) => {
    const date = new Date(param);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;
    setselected(new Date(formattedDate))
    handleInput(formattedDate)
    closeDatepicker()
  };

  const timeformathandleChange = (param, e) => {
    let date;
    if (e) {
      // Date was selected
      date = new Date(param); // Full date and time
    } else {
      // Time was selected
      const selectedDate = selected || new Date(); // previously selected date or today
      const time = new Date(param); // this has today's date with the selected time
      // Apply selected time to previously selected date
      date = new Date(selectedDate);
      date.setHours(time.getHours());
      date.setMinutes(time.getMinutes());
      date.setSeconds(0);
      date.setMilliseconds(0);
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}`;
  
    setselected(date);
    handleInput(formattedDate);
  };
  
  const handleKeyDown = e => {
    e.preventDefault(); // Prevent typing in the input field
  };

  const handleChangeRaw = (event) => {
    event.preventDefault();
  };
  
  return (
    <div className='textinput-genricpet-main'>
      {showLabel && (<label className='Genericforms-text'>{config?.renamed_block_parameter}{ifRequired && <sup>*</sup>}</label>)}
      <div style={{ display: 'flex', alignItems: 'center' }} className='generic-mydatepicker'>
      <DatePicker
          disabled={isDisabled}
          autoComplete="off"
          data-testid="datepicker"
          placeholderText={(datetype ==='date_and_time' || datetype === "future_date_and_time" || datetype === "past_date_and_time") ? "Please Select Date and Time" :"Please select Date"}
          selected={selected}
          name="startDate"
          onKeyDown={handleKeyDown}
          // onFocus={handleFocus}
          onFocus={(e) => e.target.readOnly = true}
          dropdownMode="select"
          showMonthDropdown
          showYearDropdown
          onChange={(date,e) => {(datetype ==='date_and_time' ||datetype === "future_date_and_time" || datetype === "past_date_and_time") ? timeformathandleChange(date,e) : handleChange(date,e)}}
          dateFormat={(datetype ==='date_and_time' || datetype === "future_date_and_time" || datetype === "past_date_and_time") ? "dd/MM/yyyy HH:mm" :"dd/MM/yyyy"}
          minDate={(datetype === 'future_date' || datetype === "future_date_and_time") ? new Date() : null}
          maxDate={(datetype === 'past_date' || datetype === "past_date_and_time") ? new Date() : null}
          showTimeSelect={(datetype ==='date_and_time'  || datetype === "future_date_and_time" || datetype === "past_date_and_time") ? true : false}
          timeFormat="HH:mm"
          calendarIcon={<CalendarIcon />}
          onChangeRaw={handleChangeRaw}
          className={"generic-status-update-input " + formName }
          style={{backgroundColor: formcolor ? formcolor :'rgba(108, 92, 231, 0)',border:"none"}}
          ref={(c) => calendar = c}
        />
        <button onClick={openDatepicker} style={{ marginBottom: '3px', marginLeft: '-28px', border: 'none', background: 'none', padding: 0, cursor: 'pointer' }} type="button" data-testid="mydatepicker2">
          <div className="generic-calendar-icon">
            <CalendarIcon />
          </div>
        </button>
      </div>
      <div style={{fontSize:"0.7rem",color:"#938d8d",marginLeft:'5px'}}>Please select date and time simultaneously</div>
    </div>
  );
};

MyDatePicker.propTypes = {};

export default MyDatePicker;